import { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavPaths } from './NavPaths';
import { useSelector } from 'react-redux';

const NavigationTabs = () => {
    const currentStatus = useSelector((state) => state?.candidateState.candidateInfo.info);

    const [value, setValue] = useState(() => 0);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        let pathname = location.pathname;
        let nav = NavPaths.filter((path) => `/${path.pathUrl}` === pathname);
        if (nav.length) setValue(nav[0]?.id);
    }, [location.pathname, NavPaths]);

    const NavigateToUrl = (path) => {
        navigate(path);
    };
    const checkvalidPath = (pathName) => {
        if (pathName != 'status') return true;
        if (currentStatus === 'Selected') return false;
        return true;
    };

    return (
        <>
            {currentStatus ? (
                <Tabs
                    indicatorColor='primary'
                    textColor='primary'
                    value={value}
                    variant='scrollable'
                    scrollButtons
                    allowScrollButtonsMobile
                    onChange={(e, value) => setValue(value)}
                    sx={{ pt: 3 }}>
                    {NavPaths.map(
                        (path) =>
                            checkvalidPath(path?.pathUrl) && (
                                <Tab
                                    key={path?.id}
                                    label={path.pathName}
                                    onClick={() => NavigateToUrl(path?.pathUrl)}
                                    sx={{ fontWeight: 600 }}
                                    disableRipple
                                    disableFocusRipple
                                    disableTouchRipple
                                />
                            )
                    )}
                </Tabs>
            ) : (
                ''
            )}
        </>
    );
};

export default NavigationTabs;
